export const queryProgram = `
{
  Program(id: "0fea5100-926f-4e28-a740-18628e382420") {
    _id
    Ward
    date
    leadImage {
      caption
      attribution
      asset {
        url
      }
    }
    presiding
    conducting
    openingHymn {
      number
    }
		sacramentHymn {
      number
    }
    invocation
    programItems {
    	...on Speaker {
        speaker
      }
      ...on Hymn {
        number
			}
			...on Testimonies {
        isATestimonyMeeting
      }
      ...on MusicalNumber {
        songTitle
        performers
      }
			...on Custom {
        title
        subTitle
      }
    }
    benediction
    closingHymn {
      number
    }
    announcements {
      name
      description
      date
    }
  }
}
`;
//# sourceMappingURL=queries.js.map
